<script lang="ts" setup>
import { MediaImageFragment, ParagraphTeaserGrid, ParagraphTeaserGridItem } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphTeaserGrid
}>()
const items = props.entity.fieldItems?.map((item) => {
  return {
    title: (item?.entity as ParagraphTeaserGridItem).fieldTitle,
    content: (item?.entity as ParagraphTeaserGridItem).fieldDescription?.processed,
    type: (item?.entity as ParagraphTeaserGridItem).fieldTeaserGridItemType,
    link: {
      label: (item?.entity as ParagraphTeaserGridItem).fieldLink?.title || '',
      url: (item?.entity as ParagraphTeaserGridItem).fieldLink?.uri || '',
      target: (item?.entity as ParagraphTeaserGridItem).fieldLink?.options?.attributes?.target || '_self',
    },
    image: (item?.entity as ParagraphTeaserGridItem).fieldImage?.entity as MediaImageFragment,
    label: (item?.entity as ParagraphTeaserGridItem).fieldLabel,
  }
})
</script>

<template>
  <Section>
    <ul class="items cul tl-10 tl-o-1">
      <li v-for="(item, index) in items" :key="index">
        <div :class="['visual', { 'has-background': item.type === 'key_figure' }]">
          <Image v-if="item.type === 'image'" :entity="item.image" type="employee" />
          <span v-if="item.type === 'key_figure'">{{ item.label }}</span>
        </div>
        <h4>{{ item.title }}</h4>
        <div class="description text-small" v-html="item.content" />
        <NuxtLink v-if="item.link.url" :to="item.link.url" :target="item.link.target" class="link-default">
          {{ item.link.label }}
        </NuxtLink>
      </li>
    </ul>
  </Section>
</template>
<style lang="scss" scoped>
.items {
  display: grid;
  gap: var(--gap);

  @include breakpoint('ts') {
    grid-template-columns: 1fr 1fr;
  }
  @include breakpoint('ds') {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.description {
  margin-bottom: var(--p-mb);
}
.visual {
  width: 100%;
  aspect-ratio: 16/9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  color: var(--c-primary);
  margin-bottom: 24px;
  font-weight: bold;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  &.has-background {
    background-color: var(--c-background-medium);
  }
}
</style>
